/* Newsletter offer: fixed discounts per set keep both displayed prices tidy. */
(function () {
  'use strict';
  if (window.KD_COUPON) return;
  var key = 'kokochi-newsletter-offer-v2';
  var codes = ['KOKOCHI5', 'KOKOCHI10', 'KOKOCHI15'];
  var eligible = false;
  try { eligible = localStorage.getItem(key) === 'yes'; } catch (_) {}
  var applied = false;
  function notify(value) {
    applied = value;
    document.dispatchEvent(new CustomEvent('kd:offer-state', { detail: { applied: applied } }));
  }
  var pending;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  async function apply() {
    if (!eligible) return;
    if (pending) return pending;
    pending = (async function () {
      var response = await fetch(root + 'cart.js', { cache: 'no-store' });
      if (!response.ok) throw Error('Cart could not be loaded');
      var cart = await response.json();
      // This offer replaces earlier campaign codes; its three codes apply to disjoint sets.
      var combined = codes;
      response = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: combined.join(',') })
      });
      if (!response.ok) throw Error('Offer could not be applied');
      var updated = await response.json();
      var applicable = new Set((updated.discount_codes || []).filter(function (entry) { return entry.applicable; }).map(function (entry) { return entry.code.toUpperCase(); }));
      updated.items.filter(function (item) { return Number(item.product_id) === 9283999465610; }).forEach(function (item) {
        var options = item.variant_options || (item.options_with_values || []).map(function (entry) { return entry.value; });
        var set = options.find(function (value) { return /^(5|10|15)枚セット$/.test(value); });
        var code = set && 'KOKOCHI' + set.replace('枚セット', '');
        var targets = { '5枚セット': 1089000, '10枚セット': 1689000, '15枚セット': 2089000 };
        if (!code || !applicable.has(code) || item.final_price !== targets[set] || item.final_line_price !== targets[set] * item.quantity) throw Error('Offer is not applicable to this cart');
      });
      return updated;
    })();
    try { var result = await pending; notify(true); return result; }
    catch (error) { notify(false); throw error; }
    finally { pending = null; }
  }
  function remember() {
    eligible = true;
    try { localStorage.setItem(key, 'yes'); } catch (_) {}
  }
  window.KD_COUPON = { apply: apply, remember: remember, isApplied: function(){ return applied; } };
  function showError(form) {
    var target = form || document.querySelector('cart-drawer');
    if (!target) return;
    var message = target.querySelector('.kd-offer-error');
    if (!message) {
      message = document.createElement('p');
      message.className = 'kd-offer-error'; message.setAttribute('role', 'alert');
      target.appendChild(message);
    }
    message.textContent = '登録特典を適用できませんでした。再試行するか、特典を使わず通常価格で購入できます。';
    var fallback = target.querySelector('.kd-offer-fallback');
    if (!fallback) {
      fallback = document.createElement('button'); fallback.type = 'button';
      fallback.className = 'button button--secondary kd-offer-fallback';
      fallback.textContent = '特典を使わず通常価格で購入する';
      target.appendChild(fallback);
      fallback.addEventListener('click', async function () {
        fallback.disabled = true;
        try {
          var response = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) });
          if (!response.ok) throw Error('Could not remove offer');
          var cart = await response.json();
          if (cart.total_discount !== 0) throw Error('Cart still has a discount');
          eligible = false;
          try { localStorage.removeItem(key); } catch (_) {}
          notify(false);
          window.location.href = root + 'checkout';
        } catch (error) { message.textContent = '購入手続きに進めませんでした。もう一度お試しください。'; }
        finally { fallback.disabled = false; }
      });
    }
  }
  // Cover both the cart page and drawer checkout forms. The PDP awaits apply itself.
  var resuming = new WeakSet();
  document.addEventListener('submit', function (event) {
    var form = event.target, button = event.submitter;
    if (!eligible || !button || button.name !== 'checkout' || resuming.has(form)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    button.disabled = true;
    apply().then(function () {
      button.disabled = false; resuming.add(form);
      try { form.requestSubmit(button); } finally { resuming.delete(form); }
    }).catch(function () { button.disabled = false; showError(form); });
  }, true);
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!eligible || !link || new URL(link.href).pathname !== '/checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    apply().then(function () { window.location.href = link.href; }).catch(function () { showError(); });
  }, true);
  function ready() {
    if (!eligible) return;
    apply().then(function () {
      if (window.KD_CART_SYNC) return window.KD_CART_SYNC.refresh();
    }).catch(function () { /* Checkout retries; never display an unverified discount. */ });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
